//import liraries
import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Dimensions, TouchableOpacity, Image, TextInput } from "react-native";
import QuickLinks from "../../SubComponents/Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import { autoPayDisable, autoPayEnable } from "../../api/apiManager"
import ModalAlert from "../../common/ModalAlert";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const ChangeAcType = (props) => {
  const [value, setValue] = useState("1");
  const styles = useStyles()
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
    props.setSelectedLayout('Pool Home')
  };


  const onConfirm = () => {
    if (value == "1") {
      autoPayEnable()
        .then((res) => {
          if (res.statusCode == 200) {
            setAlertModal({
              title: "Successful",
              status: "success",
              message: res?.message || "",
              navigateScreen: "PoolAccountScreen",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          } else {
            setAlertModal({
              title: "Error",
              status: "error",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          }

        })
        .catch((err) => {
          setAlertModal({
            title: "Error",
            status: "error",
            message: err?.message || "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        });
    }
    if (value == "2") {
      autoPayDisable()
        .then((res) => {
          if (res.statusCode == 200) {
            setAlertModal({
              title: "Successful",
              status: "success",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          } else {
            setAlertModal({
              title: "Error",
              status: "error",
              message: res?.message || "",
              actionButton: "OK",
            });
            setAlertModalVisible(true);
          }
        })
        .catch((err) => {
          setAlertModal({
            title: "Error",
            status: "error",
            message: err?.message || "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        });
    }
  };


  return (
    <View style={styles.mainContainer}>
      <View style={styles.iconContainer}>
        <TouchableOpacity onPress={() => { props.setSelectedLayout('PoolAc') }}>
          <Image
            source={require("../../assets/images/back.png")}
            style={styles.backIcon} />
        </TouchableOpacity>
        <Text style={styles.textStyle}>{"Pool Account Details"}</Text>
      </View>

      <View style={styles.rowContainer}>
        <View style={styles.subContainer}>
          <View style={styles.acTypeView}>
            <Text style={styles.autoPayHeading}>
              {"AutoPay Pool Account"}
            </Text>
            <Text style={styles.autoPayText}>
              {"All vehicle tags will be maintained at 0 balance, if any transaction happens on the tag of a vehicle, the amount will be deducted directly from Pool"}
            </Text>
          </View>

          <View style={styles.acTypeView}>
            <Text style={styles.autoPayHeading}>
              {"Manual Pool Account"}
            </Text>
            <Text style={styles.autoPayText}>
              {"Manual Pool Account - Transfer money from Pool Account to vehicles manually, individual vehicle balances need to be monitored"}
            </Text>
          </View>
        </View>

        <View style={styles.columnView}>
          <View style={styles.choosePoolAccountTypeView}>
            <Text style={styles.choosePoolAccountTypeHeading}>
              {" Choose Pool Account Type"}
            </Text>
            <Text style={styles.choosePoolAccountTypeText}>
              {"Transfers can be made in two different cases listed below"}
            </Text>
          </View>

          <View style={styles.radioBtnView}>
            <View style={styles.selectionContainerStyle}>
              <TouchableOpacity onPress={() => setValue("1")}
                style={styles.radiobuttonOutSideStyle} >
                {
                  value == "1"
                    ? <View style={styles.radioButtonInsideStyle} />
                    : null
                }
              </TouchableOpacity>
              <Text style={{ fontSize: 13, color: "#02122c", marginLeft: 7 }}>
                {"AutoPay Pool Account"}
              </Text>
            </View>
            <View style={styles.selectionContainerStyle}>
              <TouchableOpacity onPress={() => setValue("2")}
                style={styles.radiobuttonOutSideStyle} >
                {
                  value == "2"
                    ? <View style={styles.radioButtonInsideStyle} />
                    : null
                }
              </TouchableOpacity>
              <Text style={{ fontSize: 13, color: "#02122c", marginLeft: 7 }}>
                {"Manual Pool Account"}
              </Text>
            </View>

          </View>
        </View>
      </View>

      <View style={styles.customButton}>
        <CustomButton
          text="Save Changes"
          onPress={() => onConfirm()}
        />
      </View>

      <View>
        <QuickLinks navigation={props.navigation} />
      </View>

      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle({
  mainContainer: {
    width: "100%",
    height: 450,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginLeft: 20,
  },
  iconContainer: {
    marginTop: "2%",
    flexDirection: isSmallDevice || isTabView ? "column" : "row",
    paddingLeft: 30,
    paddingHorizontal: isSmallDevice || isTabView ? null : 50,
    marginLeft: isSmallDevice || isTabView ? null : 10,
  },
  backIcon: {
    height: 19,
    width: 19,
    resizeMode: "center",
    opacity: 0.8,
  },

  textStyle: {
    color: '#999999',
    fontSize: 13,
    marginLeft: 20,
  },
  rowContainer: {
    flexDirection: 'row',
  },
  subContainer: {
    flexDirection: 'column',
    width: 281,
    height: 185.5,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ff6e6e",
    marginLeft: 70,
    marginTop: 20,
    justifyContent: 'space-between'
  },
  acTypeView: {
    flexDirection: 'column',
    width: 280,
    height: 96.2,
  },
  autoPayHeading: {
    width: 150,
    height: 16,
    fontSize: 14,
    fontWeight: "600",
    color: "#bd2d37",
    marginLeft: 20,
    paddingTop: 10
  },
  autoPayText: {
    width: 247,
    fontSize: 11,
    fontWeight: "500",
    color: "#02122c",
    marginLeft: 20,
    paddingTop: 15,
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 15,
  },
  columnView: {
    flexDirection: 'column',
    marginLeft: 50
  },
  choosePoolAccountTypeView: {
    width: 323,
    height: 70,
    justifyContent: 'space-between'
  },
  choosePoolAccountTypeHeading: {
    fontSize: 17,
    fontWeight: "bold",
    color: "#5f5f5f",
  },
  choosePoolAccountTypeText: {
    fontSize: 16,
    fontWeight: "300",
    color: "#757575",
  },
  radioBtnView: {
    paddingTop: 40,
    height: 90,
    justifyContent: 'space-between',
  },
  selectionContainerStyle: {
    flexDirection: 'row',
  },
  radiobuttonOutSideStyle: {
    width: 15,
    height: 15,
    borderRadius: 10,
    borderColor: "#9d1d27",
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center"
  },
  radioButtonInsideStyle: {
    height: 7,
    width: 7,
    borderRadius: 7,
    backgroundColor: "#9d1d27"
  },
  chooseOptionStyle: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: 17,
    letterSpacing: 0,
    textAlign: "left",
    color: "#797673"
  },
  customButton: {
    width: 218,
    height: 37,
    marginLeft: 700
  }


},
  {
    [DEVICE_SIZES.SM]:
    {
      mainContainer:
      {
        width: 528.1,
        height: 730.3,
      },
      rowContainer: {
        flexDirection: 'column',
      },
      columnView: {
        flexDirection: 'column',
        marginLeft: 50
      },
      columnView: {
        marginTop: 20,
        marginLeft: 70,
      },
      customButton: {
        width: 218,
        height: 37,
        marginLeft: 300,
        marginTop: 30
      },
      choosePoolAccountTypeText:{
        width:'90%'
      }
    },

    [DEVICE_SIZES.MD]:
    {
      mainContainer:
      {
        flexDirection: 'column',
        width: 528.1,
        height: 730.3,
      },
      rowContainer: {
        flexDirection: 'column',
      },
      columnView: {
        marginTop: 20,
        marginLeft: 70,
      },
      customButton: {
        width: 218,
        height: 37,
        marginLeft: 300,
        marginTop: 30
      }
    },
    [DEVICE_SIZES.XS]:
    {
      mainContainer:
      {
        flexDirection: 'column',
        width: 321.8,
        height: 754,
      },
      rowContainer: {
        flexDirection: 'column',
      },
      subContainer: {
        flexDirection: 'column',
        width: 281,
        height: 185.5,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ff6e6e",
        marginLeft: 20,
        marginTop: 20,
        justifyContent: 'space-between'
      },
      columnView: {
        marginTop: 30,
        marginLeft: 25,
      },
      customButton: {
        width: 154.2,
        height: 31.3,
        marginLeft: 130,
        marginTop: 100
      },
      choosePoolAccountTypeText:{
        width:'90%'
      }

    },
  }
);

//make this component available to the app
export default ChangeAcType;
